// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__LF-4q","container":"style_container__vQXGE","title_input_container":"style_title_input_container__AWlk+","submit_btn":"style_submit_btn__IxcJj"};